import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsMessagingAppsWhatsappRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-messaging-apps-whatsapp',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/messaging-apps/whatsapp',
	exact: true,
};
